<script setup lang="ts">
import type { MenuItem } from "@/utils/types";

defineProps<{
  menuItems: MenuItem[];
}>();
const emit = defineEmits(["closeMenu"]);
// Cache icon components to prevent duplicate imports
const { getIconComponent } = useDynamicIconComponent();
</script>

<template>
  <ul>
    <li v-for="item in menuItems" :key="item.label" class="mb-3">
      <NuxtLink
        :to="item.to"
        class="duration-400 flex items-center rounded-lg p-3 px-1 text-sm font-medium
          text-gray-900 transition-all ease-linear hover:bg-[#0000001F] xl:px-3
          xl:text-surface-0"
        :class="[{ 'bg-[#0000001F]': $route.path === item.to }]"
        :style="{
          backgroundColor: $route.path === item.to ? '#0000001F' : '',
        }"
        @click="emit('closeMenu')"
      >
        <component :is="getIconComponent(item.icon)" class="mr-2" />
        <span>{{ item.label }}</span>
      </NuxtLink>
    </li>
  </ul>
</template>
